import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import deprecated from '../lib/deprecated';
import Icon from './Icon';

export default class Alert extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hidden: false,
        };

        this.hide = this.hide.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    render() {
        let variations = this.props.variations.slice();

        if (this.props.alertType) {
            deprecated(
                "alertType={${this.props.alertType}} is deprecated, use variations={['`${this.props.alertType}`']}"
            );
            variations = [this.props.alertType];
        }

        var alertClasses = getComponentClasses('alert', variations);

        if (this.state.hidden) {
            return null;
        }

        return (
            <div className={alertClasses}>
                <div className="alert__icon">{this.props.icon || this.defaultIcon()}</div>
                <div className="alert__body">
                    <div className="alert__message">{this.props.children}</div>
                </div>
                {this.hideButton()}
            </div>
        );
    }

    defaultIcon() {
        return <Icon variations={['exclamation-point-1']} />;
    }

    hideButton() {
        if (!this.props.canBeDismissed) {
            return null;
        }

        return <div className="alert__dismiss" onClick={this.hide} />;
    }

    hide() {
        this.setState({ hidden: true }, this.onHide);
    }

    onHide() {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    }
}

Alert.propTypes = {
    variations: PropTypes.array,
    icon: PropTypes.element,
    canBeDismissed: PropTypes.bool,
    onDismiss: PropTypes.func,
};

Alert.defaultProps = {
    variations: ['info'],
    canBeDismissed: false,
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Alert.jsx